import React, { Fragment } from 'react';
import { object, bool } from 'prop-types';

import { Title } from '../styled-components';
import { Wrapper } from './styled-components';
import { SpinnerWithBackground } from '../../components/ui-helpers/';
import { RequestSourcesList, RequestLabelsList, RequestStatusesList } from './settings-sections';

const OrganizationSettingsModalComp = ({ isLoading, settings, editable }) => (
  <Fragment>
    {isLoading && <SpinnerWithBackground />}

    <Title>Organization settings</Title>
    <Wrapper>
      <RequestSourcesList
        items={settings.requestSources}
        listTitle={'Request\'s Sources'}
        keyPrefix="request-source"
        settingsType="Source"
        editable={editable}
      />
      <RequestStatusesList
        items={settings.requestStatuses}
        listTitle={'Request\'s Statuses'}
        keyPrefix="request-status"
        settingsType="Status"
        editable={editable}
      />
      <RequestLabelsList
        items={settings.requestLabels}
        listTitle={'Request\'s Labels'}
        keyPrefix="request-label"
        settingsType="Label"
        editable={editable}
      />
    </Wrapper>
  </Fragment>
);

OrganizationSettingsModalComp.propTypes = {
  isLoading: bool.isRequired,
  settings: object.isRequired,
  editable: bool.isRequired,
};

export default OrganizationSettingsModalComp;



// WEBPACK FOOTER //
// ./src/modals/organization-settings-modal/organization-settings-modal-comp.js